$(document).ready(function() {

    'use strict';

    var c, currentScrollTop = 0,
        navbar = $('#gh-head');

    $(window).scroll(function() {
        var a = $(window).scrollTop();
        var b = navbar.height();

        currentScrollTop = a;

        if (c < currentScrollTop && a > b + b) {
            navbar.addClass("scrollUp");
        } else if (c > currentScrollTop && !(a <= b)) {
            navbar.removeClass("scrollUp");
        }
        c = currentScrollTop;

    });
});
var inputField = document.getElementById("search-input");
if (inputField) {

    new GhostFinder({
        input: '#search-input',
        showResult: '#search-result',
        contentApiKey: 'd21360f2ad25060521b6182d3b',
        time_format: 'dd-MM-yyyy',
        singleResultTemplate: '<article class="post-card post-search"><a class="post-card-image-link" href="##url"><img class="post-card-image" src="##feature_image" loading="lazy"/></a>' +
            '<div class="post-card-content">' +
            '<a class="post-card-content-link" href="##url">' +
            '<header class="post-card-header">' +
            '<div class="post-card-primary-tag">##primary_tag_name</div>' +
            '<h2 class="post-card-title">##title</h2></header></a>' +
            '<footer class="post-card-meta">' +
            '<ul class="author-list">' +
            '<li class="author-list-item">' +
            '<a href="##primary_author_url" class="static-avatar">' +
            '<img class="author-profile-image" src="##primary_author_avater" alt="##primary_author_name" />' +
            '</a></li></ul>' +
            '<div class="post-card-byline-content">' +
            '<span>##primary_author_name</span>' +
            '<span class="post-card-byline-date"><time datetime="##published_at">##published_at</time>' +
            '</div></footer></div></article>',
        resultTemplate: '<p class="item-total"> Foram encontrados ##resultCount resultado(s) </p> ##results'
    });

    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    if (urlParams.has('s')) {
        inputField.value = urlParams.get('s');

        setTimeout(function() {
            inputField.dispatchEvent(new KeyboardEvent('keyup', { 'key': 'h' }));
        }, 500);
    }
}

function loadVideo(url) {
    var video = document.getElementById("video-iframe");
    if (video) {
        video.setAttribute("src", "https://www.youtube.com/embed/" + url);
    }
}

const blurLoad = document.querySelectorAll('.blur-load');

blurLoad.forEach((item) => {
    const img = item.querySelector('img');

    function loaded() {
        item.classList.add('image-loaded');
    }

    if (img.complete) {
        loaded();
    } else {
        img.addEventListener('load', loaded);
    }

});

new PerformanceObserver((list) => {
    const latestEntry = list.getEntries().at(-1);

    if (latestEntry?.element?.getAttribute('loading') == 'lazy') {
        console.warn('Warning: LCP element was lazy loaded', latestEntry);
    }
}).observe({type: 'largest-contentful-paint', buffered: true});
